import React from 'react';
import {Dialog, Portal} from "@chakra-ui/react";
import Quiz from "./Quiz";

const DialogOverlay = (props) => {
    const { title, content, ...rest } = props
    return (
        <Dialog.Root
            placement="center"
            motionPreset="slide-in-bottom"
            {...rest}
        >
            <Portal>
                <Dialog.Backdrop/>
                <Dialog.Positioner>
                    <Dialog.Content maxW={"50%"} display="flex" flexDirection="column">
                        <Dialog.Header p={10}>
                            <Dialog.Title textAlign="center" width="100%" fontSize={{base: "lg", md: "2xl"}}>{title}</Dialog.Title>
                        </Dialog.Header>
                        <Dialog.Body p={4}>
                            <Quiz />
                        </Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    )
};

export default DialogOverlay;